const props = (props) => ({
  save: (settings) => {
    props.updateCompanyDispatch(settings)
  }
})

export default props
